import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Section} from "../../../../../framework/model/core/sections/section";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {Events} from "../../../../../framework/providers/events";
import {Swiper} from "swiper";

@Component({
    selector: 'app-sections-grid-slider',
    templateUrl: './sections-grid-slider.component.html',
    styleUrls: ['./sections-grid-slider.component.scss']
})
export class SectionsGridSliderComponent implements OnInit {
    @ViewChild('swiper', { static: false }) swiperRef!: ElementRef;
    public swiperInstance: any;

    public models: Array<Section> = [];
    public prefix = 'sectionsgrid'
    @Input() options: object = {rows: 2, cols: 8};

    public slides = [];

    constructor(public tools: ModelToolsProvider, public events: Events,) {
    }

    ngOnInit() {
        // Initialization logic can go here
        this.options = {
            ...this.options,
            'slidesPerView': this.options['cols']
        };


        this.events.subscribe(this.prefix + '_modelUpdated', (res) => {
            this.setSlides();
        })
    }


    ngOnDestroy()
    {
        this.events.unsubscribe(this.prefix + '_modelUpdated')
    }

    ngAfterViewInit() {
    setTimeout(() => {
      if (this.swiperRef?.nativeElement?.swiper) {
        this.swiperInstance = this.swiperRef.nativeElement.swiper;

        //console.log("Swiper initialized", this.swiperInstance);
      } else {
        //console.error("Swiper instance not found in nativeElement");
      }
    }, 100); // Ensure DOM updates first
  }

    setSlides() {
        this.slides.length = 0;
        const numSectionsPerSlide = this.options['rows']// * this.options.cols;
        let slides = [];

        for (let i = 0; i < this.models.length; i += numSectionsPerSlide) {
            slides.push(this.models.slice(i, i + numSectionsPerSlide));
        }

        this.slides = slides;
    }

    slideNext() {
        this.swiperInstance.slideNext();
    }

    slidePrev() {
        this.swiperInstance.slidePrev();
    }

    goTo(model) {
        this.tools.goTo('section/' + model.data['id']);
    }

}
